import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

import { Habit } from './_types';
import { denormalizeHabit, normalizeHabit } from './normalizers';

export * from './_types';

export const HabitsQueryKey = ['habits'];

export const fetchHabit = async (habitId: Identifier): Promise<Habit> => {
  const response = await api.get(`/api/v4/habits/${habitId}`);
  return normalizeHabit(response.data);
};

export const fetchHabits = async (): Promise<Habit[]> => {
  const response = await api.get('/api/v4/habits', {
    params: {
      fetch_all: true,
      'q[s]': 'name asc',
    },
  });
  const payload = response.data?.habit ?? response.data;
  const rows = Array.isArray(payload) ? payload : [];
  return rows.map((habit: unknown) => normalizeHabit(habit));
};

export const fetchHabitsForWorkoutPlan = async (
  workoutPlanId: Identifier
): Promise<Habit[]> => {
  const response = await api.get('/api/v4/habits', {
    params: {
      fetch_all: true,
      workout_plan_id: workoutPlanId,
    },
  });
  const payload = response.data?.habit ?? response.data;
  const rows = Array.isArray(payload) ? payload : [];
  return rows.map((habit: unknown) => normalizeHabit(habit));
};

export const createHabit = async (
  habitData: Omit<Habit, 'id'>
): Promise<Habit> => {
  const response = await api.post('/api/v4/habits', {
    habit: denormalizeHabit(habitData),
  });
  return normalizeHabit(response.data);
};

export const updateHabit = async (habitData: Habit): Promise<Habit> => {
  const { id, ...rest } = habitData;
  const response = await api.put(`/api/v4/habits/${id}`, {
    habit: denormalizeHabit(rest),
  });
  return normalizeHabit(response.data);
};

export const deleteHabit = async (habitId: Identifier): Promise<Habit> => {
  const response = await api.delete(`/api/v4/habits/${habitId}`);
  return normalizeHabit(response.data);
};

export const fetchHabitCurrentGoal = async (
  habitId: Identifier,
  userId: Identifier,
  date: string,
  timeZone: string
): Promise<number | null> => {
  const response = await api.get(`/api/v4/habits/${habitId}/current_goal/`, {
    params: {
      user_id: userId,
      date_string: date,
      time_zone: timeZone,
    },
  });
  return response.data;
};

export const updateHabitGoal = async (
  habitId: Identifier,
  userId: Identifier,
  value: number | null,
  date: string,
  timeZone: string,
  dateNumber?: number
): Promise<void> => {
  await api.post(`/api/v4/habits/${habitId}/update_goal/`, {
    user_id: userId,
    value,
    date_string: date,
    time_zone: timeZone,
    date: dateNumber,
  });
};
